import { render, staticRenderFns } from "./participant-tasks-table.vue?vue&type=template&id=ab63cca0&"
import script from "./participant-tasks-table.vue?vue&type=script&lang=js&"
export * from "./participant-tasks-table.vue?vue&type=script&lang=js&"
import style0 from "@/assets/table-styling.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./participant-tasks-table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "participant-tasks-table.vue"
export default component.exports